<template>
  <table class="table-main">
    <tr>
      <td class="simulation">
        <simulation
          v-if="enterpriseID"
          :ID="enterpriseID"
          :onAdd="handleAdd"
          :onEdit="handleEdit"
        />
        <v-snackbar
          top
          right
          v-model="snackbar"
          :timeout="timeout"
          :color="messageColor"
        >
          {{ message }}
          <v-btn
            color="black"
            text
            @click="snackbar = false"
          >
            {{ $t('common.close') }}
          </v-btn>
        </v-snackbar>
      </td>
      <td id="mainForm" v-resize="onResize" >
        <h1 style="margin-left: 20px;margin-top: 15px;margin-bottom: 5px;">
          <v-icon
            style="margin-bottom:5px;font-size:30px; color: rgba(0, 0, 0, 0.87);"
            @click="handleGoToConfigEnterprise"
          >
            mdi-cellphone-cog
          </v-icon>{{ enterpriseName }}</h1>
        <v-layout wrap>
          <v-flex xs12 sm12 md8 >
            <v-card
              ref="form-menu"
              class="pa-4"
              flat
              style="margin: 0 15px 0;"
            >
              <info
                v-if="!editTMP"
                :onAdd="isCommonMenus ? null : handleAdd"
              />
              <!-- <translate
                v-model="prueba"
                :languages="['es', 'en']"
                :label="$t('menuType.title')"
                type="richText"
                style="padding: 0 10px 0 10px;"
              /> -->
              <form-header
                v-if="editTMP"
                :editTMP="editTMP"
              />
              <form-menu
                v-if="editTMP"
                :editTMP="editTMP"
                :onCancel="handleCancelPreviusEdit"
                :onShowMessage="handleShowMessage"
                :onEdit="handleEdit"
                :scrollPosition="scrollPosition"
                :onSaved="handleSaved"
              />
            </v-card>
            <confirm-undo
              :showDialog="showConfirmUndo"
              :onKO="handleKOUndo"
              :onOK="handleOKUndo"
              :undoNewValue="undoNewValue"
            />
          </v-flex>
          <v-flex xs0 sm0 md4>
            <custom-tree
              v-if="enterpriseID && !isCommonMenus"
              :enterpriseID="enterpriseID"
              :onSelectNode="handleSelectMenuByID"
              :updateCustomTree="updateCustomTree"
              :onUpdate="handleCustomTreeUpdate"
            />
          </v-flex>
        </v-layout>
      </td>
    </tr>
  </table>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import constants from '@/constants'
  import utils from '@/services/utils.js'
  import Simulation from '@/views/public/mobile/Index'
  import Info from './Info'
  import CustomTree from './CustomTree'
  import FormHeader from './formMenu/FormHeader'
  import FormMenu from './formMenu/Index'
  import ConfirmUndo from '@/components/ConfirmUndo'

  import Translate from '@/components/Translate'
  export default {
    components: {
      Simulation,
      Info,
      CustomTree,
      FormHeader,
      FormMenu,
      ConfirmUndo,
      Translate
    },
    data: () => ({
      mainForm: {},
      contMenu: 0,
      updateCustomTree: false,
      // editTMP: null,
      editTMPBK: null,
      showConfirmUndo: false,
      undoNewValue: null,
      snackbar: false,
      message: false,
      messageColor: 'success',
      timeout: 3000,

      scrollPosition: null
    }),
    computed: {
      ...mapState('app',['editTMP', 'BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont']),
      ID () {
        return this.$route.params.id
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseName () {
        return this.$store.state.app.enterpriseName
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      isAdmin () {
        return this.$store.state.app.isAdmin
      },
      isCommonMenus () {
        return !this.isAdmin && this.$route.path === '/common-menus' ? true : false
      },
    },
    watch:{
      $route (to, from){
        if (to.path && to.path !== from.path) {
          if (to.path.length > 0) {
            this.handleOKUndo()
          }
        }
      },
      '$store.state.app.enterpriseID' () {
        this.prepareAutoTranslate()
      },
    },
    mounted () {

      this.onResize()
      this.handleOKUndo()

      const that = this
      setTimeout(function(){
        that.handleEditAfterMove()
      }, 1000)

      this.prepareAutoTranslate()
    },
    methods: {
      prepareAutoTranslate () {
        if (!this.enterpriseID) return

        api.getItem(`enterprises`, true,`${this.enterpriseID}/deepl-translate/`).then(response => {
          this.$store.state.app.dtouchDeeplTranslateActive = response.DtouchDeeplTranslateActive ? true : false
          this.$store.state.app.dtouchDeeplTranslateLocale = response.DtouchDeeplTranslateLocale ? response.DtouchDeeplTranslateLocale : 'es'
        })
      },
      handleSaved () {
        //const v = JSON.parse(JSON.stringify(this.$store.state.app.editTMP))
        //console.log('aaa', v)
        //this.handleOKUndo()
        //this.$store.state.app.contents = []
        // aceptan el deshacer los cambios
        const { editTMP } = this.$store.state.app
        if (editTMP && editTMP.ID)
          this.$store.state.app.forceRefreshOnSave = { lmd: new Date().toISOString(), id: editTMP.ID}

        this.$store.state.app.isModified = false
        this.$store.state.app.editTMP = null//newValue
        this.editTMPBK = null// v ? JSON.parse(JSON.stringify(v)) : newValue
        //if (v && v.isNew && !v.isSecundary) {
        //  this.$store.state.app.isModified = true
        //  this.$store.state.app.menus.push(v)
        //}
        // obtenemos el contenido del menú en edición
        //this.$store.state.app.contents = []
        //if (v && !v.isNew && v.Type === 0) this.handleGetContent(v.ID)
      },
      handleEditAfterMove () {
        //ini para que al clonar redir a la menú clonado
        if (this.ID && this.ID.length > 0 ) {
          const aux = this.$store.state.app.menus.filter(x => x.ID === this.ID)
          if (aux.length > 0) {
            // si se clona un menu
            this.handleEdit(aux[0], null)
          } else {
            // si no encuentra el menu busca en los submenus
            const submenus = this.$store.state.app.menus.filter(x => x.Menus)
            for (let i = 0; i < submenus.length; i++) {
              const aux = submenus[i].Menus.filter(x => x.ID === this.ID)
              if (aux.length > 0) this.handleEdit(aux[0], null)
            }
          }
        }
        //end para que al clonar redir a la menú clonado

        history.pushState(
          {},
          null,
          process.env.VUE_APP_ENV === 'development' ? 'http://dtouch.local:8006/' + '#/menus' : 'https://www.dtouch.es/' + '#/menus'
        )
      },
      onResize () {
        this.$store.state.app.mainFormWidth = document.getElementById('mainForm').offsetWidth // window.innerWidth
      },
      scrollMeTo(refName) {
        if (refName !== 'form-menu') {
          this.scrollPosition = refName
        } else {
          const element = this.$refs[refName]
          const top = element.offsetTop
          window.scrollTo(0, top)
        }
      },
      handleSelectMenuByID (menuID, isSubmenu, isContent, id, anchor) {
        if (menuID) return
        // método utilizado al seleccionar un menú del arbol de la derecha
        if (isSubmenu) {
          const submenus = this.$store.state.app.menus.filter(x => x.Menus)
          for (let i = 0; i < submenus.length; i++) {
            const aux = submenus[i].Menus.filter(x => x.ID === menuID)
            if (aux.length > 0) this.handleEdit(aux[0], anchor)
          }
        } else {
          const aux = this.$store.state.app.menus.filter(x => x.ID === menuID)
          if (aux.length > 0) this.handleEdit(aux[0], anchor)
        }
      },
      handleKOUndo () {
        // cancelan el deshacer los cambios
        this.showConfirmUndo = false
      },
      handleOKUndo (newValue) {
        // aceptan el deshacer los cambios
        this.$store.state.app.isModified = false
        if (this.editTMPBK) {
          //alert(this.$store.state.app.editTMP ? this.$store.state.app.editTMP.noRestore : null)
          //if (!this.$store.state.app.editTMP || !this.$store.state.app.editTMP.noRestore) {
            // si es nuevo lo eliminamos del array, de lo contrario igualamos los valores con el BK
            if (this.$store.state.app.editTMP.isNew) {
              this.$store.state.app.menus = this.$store.state.app.menus.filter(x => !x.isNew)
            } else {
              utils.transfMenu(this.$store.state.app.editTMP, this.editTMPBK, this.$store.state.app.menus)
            }
          //}
        }
        // if (newValue) {
        this.$store.state.app.editTMP = newValue
        this.editTMPBK = newValue ? JSON.parse(JSON.stringify(newValue)) : newValue
        if (newValue && newValue.isNew && !newValue.isSecundary) {
          this.$store.state.app.isModified = true
          this.$store.state.app.menus.push(newValue)
        }
        // }
        // obtenemos el contenido del menú en edición
        this.$store.state.app.contents = []
        if (newValue && !newValue.isNew && (newValue.Type === 0 || newValue.Type === null)) this.handleGetContent(newValue.ID)

        this.showConfirmUndo = false
      },
      handleGetContent (id) {
        this.$store.state.app.loadingContents = true
        api.getAll(`contents/${id}`, true, id).then(response => {
          this.$store.state.app.contents = response.map(item => {
            item.MenuContentID = item.MenuContentID ? item.MenuContentID : item.ID
            return item
          })
          this.$store.state.app.loadingContents = false
        })
        .catch (error => {
          this.$store.state.app.loadingContents = false
        })
      },
      handleCancelPreviusEdit (newValue) {
        // si se ha modificado el contenido pregunta antes de deshacer los cambios
        if (this.$store.state.app.isModified) {
          this.undoNewValue = newValue
          this.showConfirmUndo = true
        } else {
          // si no se ha modificado se deshacen los cambios
          this.handleOKUndo(newValue)
        }
      },
      handleAdd () {
        this.contMenu++
        const newMenu = JSON.parse(JSON.stringify(constants.menuNewValueDefault))
        newMenu.ID = newMenu.ID.concat('_', this.contMenu)
        const max = this.$store.state.app.menus.length > 0 ? this.$store.state.app.menus.reduce(function(prev, current) {
            return (prev.ORD > current.ORD) ? prev : current
        }) : 0
        newMenu.ORD = max.ORD + 1
        this.handleCancelPreviusEdit(newMenu)
      },
      handleEdit(menu, anchor) {
        menu.WebAppAsContentDomain = menu.WebAppAsContentDomain ? menu.WebAppAsContentDomain.replace('@#@', '?') : null
        if (anchor) {
          this.scrollMeTo(anchor)
        } else {
          this.scrollMeTo('form-menu')
        }
        this.handleCancelPreviusEdit(menu)
      },
      handleShowMessage (message, color) {
        this.updateCustomTree = true

        this.message = message
        this.messageColor = color
        this.snackbar = true
      },
      handleCustomTreeUpdate () {
        // Fuerza a actualizar los datos del arbol de contenido
        this.updateCustomTree = false
      },
      handleGoToConfigEnterprise () {
        if(this.isAdmin) this.$router.push(`enterprises/${this.enterpriseID}`)
      }
    }
  }
</script>
<style lang="scss">
  h1 {
    font-weight: normal;
  }
  .table-main {
    width: 100%;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }
  .simulation {
    width: 400px;
    padding: 20px 5px 0px 20px;
  }
</style>
